import {SActionBtn, SLowcodeList, STableActions} from "shj-components";
import {config} from "./config.tsx";
import {openEdit} from "./edit.tsx";
import {useRef} from "react";
import {tableApiFunc, treeFormat} from "@/utils/data.ts";
import {deleteMemberEquityCategory, queryMemberEquityCategoryListByPage} from "@/services/member.ts";
import {message} from "antd";

/**
 *
 * 权益分类
 * @constructor
 */
function Page() {

    const tableRef = useRef<any>()
    const onAddOrEdit = (data: any = {}, title: string) => {
        openEdit({
            title: title + '权益分类',
            data: {...data, parentId: data?.parentId === '0' ? null : data?.parentId},
            destroy: (success) => {
                if (success) {
                    tableRef.current.reload()
                }
            }
        });
    }

    const onDelete = (id) => {
        deleteMemberEquityCategory({id}).then(() => {
            message.success('删除成功')
            tableRef.current.reload()
        })
    }

    const extensions = {
        request: {
            fetchList: tableApiFunc(queryMemberEquityCategoryListByPage, {
                paginationInBody: true,
                fieldNames: {current: 'current'},
                transformResult: (result: any) => {
                    return treeFormat(result, {
                        children: 'childList',
                        childrenEmptyData: null,
                        format: (data, {level}) => ({...data, level})
                    });
                }
            }),
        },
        events: {onAdd: () => onAddOrEdit({}, '新增')},
        customRender: {
            actionRender(_: null, record: Record<string, any>) {
                console.log(_, record)
                return (
                    <STableActions>
                        {
                            record.level == 1 && (
                                <SActionBtn onClick={() => onAddOrEdit({parentId: record.id}, '新增')}>新增</SActionBtn>
                            )
                        }
                        <SActionBtn onClick={() => onAddOrEdit(record, '编辑')}>编辑</SActionBtn>
                        <SActionBtn isDelete onClick={() => onDelete(record.id)}>删除</SActionBtn>
                    </STableActions>
                )
            }
        }
    }
    return (
        <div>
            <div>
                <SLowcodeList
                    tableType='antd'
                    searchMode={'group'}
                    config={config}
                    {...extensions}
                    ref={tableRef}
                    expandable={{
                        childrenColumnName: 'childList'
                    }}

                />
            </div>
        </div>
    );
}

export default Page;
